import { fetchClient } from '@/util/fetchClient';

/**
 * Persist this user's read horizon for a conversation so `/v2/inquiries/unread`
 * reflects "read" immediately (don't wait for Twilio webhooks).
 */
export async function markInquiryReadV2(conversationId: string) {
  const { data } = await fetchClient.POST('/v2/inquiries/{conversationId}/read', {
    params: { path: { conversationId } },
  });

  return data;
}
